import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function AvarageMachineSellFilter({
  currentPage,
  totalPages,
  setCurrentPage,
  machineFilter,
  setMachineFilter,
  itemsPerPage,
  setItemsPerPage,
  filteredData,
  totalCount,
  paymentType,
  setPaymentType,
  machines,
  sortType,
  setSortType,
  isVisible,
  setIsVisible,
  showAVG,
  setShowAVG,
  getData= () => {},
  setShowMedian,
  showMedian,
  machineRank,
  setMachineRank,
  chartType="monthly",
  title="Sprzedaż (automaty)",
  timeRange,
  setTimeRange
}) {
  const sortLabels = {
    1: "↓ Suma",
    2: "↓ Średnia",
    3: "↓ Nazwa",
    4: "↑ Suma",
    5: "↑ Średnia",
    6: "↑ Nazwa",
  };

  const ToggleVisibility = (
    <div className="d-flex align-items-center">
      <div
        onClick={() => {
          setIsVisible((prev) => !prev);
        }}
      >
        <div>
          <i
            className={`fas fa-toggle-${
              !isVisible ? `off text-secondary ` : `on text-primary`
            } fa-lg`}
          />
        </div>
      </div>
      <div
        className="h6 mb-0 ml-2 w-100 d-flex justify-content-center"
        style={{ fontSize: ".8rem" }}
      >
        {title}
      </div>
    </div>
  );
  return isVisible ? (
    <div className="mt-3">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex mb-2 justify-content-around">
          <div className="d-flex justify-content-center align-items-center justify-content-around mr-2">
            <div className="mr-2 form-check">
              <input
                className="form-check-input"
                type="radio"
                name={`paymentType-average-machine-sale-${chartType}`}
                id={`paymentTypeAll-average-machine-sale-${chartType}`}
                value=""
                checked={!paymentType}
                onChange={() => setPaymentType(null)}
              />
              <label
                className="form-check-label"
                htmlFor={`paymentTypeAll-average-machine-sale-${chartType}`}
              >
                Razem
              </label>
            </div>
            <div className="mr-2 form-check">
              <input
                className="form-check-input"
                type="radio"
                name={`paymentType-average-machine-sale-${chartType}`}
                id={`paymentTypeCard-average-machine-sale-${chartType}`}
                value="1"
                checked={paymentType == 1}
                onChange={() => setPaymentType(1)}
              />
              <label
                className="form-check-label"
                htmlFor={`paymentTypeCard-average-machine-sale-${chartType}`}
              >
                Karta
              </label>
            </div>
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`paymentType-average-machine-sale-${chartType}`}
                id={`paymentTypeCash-average-machine-sale-${chartType}`}
                value="2"
                checked={paymentType == 2}
                onChange={() => setPaymentType(2)}
              />
              <label
                className="form-check-label"
                htmlFor={`paymentTypeCash-average-machine-sale-${chartType}`}
              >
                Gotówka
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className=" ml-2 mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`machineRank-filter-${chartType}`}
                id={`machineRankAll${chartType}`}
                value="all"
                checked={machineRank === "all"}
                onChange={() => setMachineRank("all")}
              />
              <label
                className="form-check-label"
                htmlFor={`machineRankAll${chartType}`}
              >
                Wszystkie
              </label>
            </div>
            <OverlayTrigger overlay={<Tooltip>Najlepsze 50</Tooltip>}>
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`machineRank-filter-${chartType}`}
                id={`machineRankBest${chartType}`}
                value="best"
                checked={machineRank === "best"}
                onChange={() => setMachineRank("best")}
              />
              <label
                className="form-check-label"
                htmlFor={`machineRankBest${chartType}`}
              >
                Najlepsze
              </label>
            </div>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Najlepsze 50</Tooltip>}>
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`machineRank-filter-${chartType}`}
                id={`machineRankWorst${chartType}`}
                value="worst"
                checked={machineRank === "worst"}
                onChange={() => setMachineRank("worst")}
              />
              <label
                className="form-check-label"
                htmlFor={`machineRankWorst${chartType}`}
              >
                Najgorsze
              </label>
            </div>
            </OverlayTrigger>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 mb-2">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {/* <label htmlFor="itemsPerPage" className="mr-2 mb-0">
                Pokaż:
              </label>
              <select
                id="itemsPerPage"
                className="form-control form-control-sm mr-2"
                style={{ width: "70px" }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select> */}
            </div>
            <div className="d-flex align-items-center">
              <button
                className="card btn-sm mr-2"
                style={{ backgroundColor: "#FF7A00", color: "white", height: "2rem" }}
                onClick={() => setShowAVG(!showAVG)}
              >
                {showAVG ? "Ukryj" : "Pokaż"} średnią
              </button>
              <button
                className="card btn-sm mr-2"
                style={{ backgroundColor: "#666A71", color: "white", height: "2rem" }}
                onClick={() => setShowMedian(!showMedian)}
              >
                {showMedian ? "Ukryj" : "Pokaż"} medianę
              </button>
              <button
                className="card btn-sm fas fa-redo mr-2"
                style={{ backgroundColor: "#0140BE", color: "white", height: "2rem"}}
                onClick={getData}
              >
              </button>
              {chartType !== "year" && (
                <div className="d-flex align-items-center mr-2">
                  <label htmlFor="timeRange" className="mr-2 mb-0">
                    Zakres:
                  </label>
                  <select
                    id="timeRange"
                    className="form-control form-control-sm"
                    style={{ width: "110px" }}
                    value={timeRange}
                    onChange={(e) => {
                      setTimeRange(e.target.value);
                    }}
                  >
                    <option value="24h">24 h</option>
                    <option value="72h">72 h</option>
                    <option value="7d">7 dni</option>
                    <option value="30d">30 dni</option>
                  </select>
                </div>
              )}
              <label htmlFor="sortBy" className="mr-2 mb-0">
                Sortuj:
              </label>
              <select
                id="sortBy"
                className="form-control form-control-sm mr-2"
                style={{ width: "110px" }}
                value={sortType}
                onChange={(e) => {
                  setSortType(+e.target.value);
                }}
              >
                {Object.entries(sortLabels).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            {/* <div>
                <span>
                  {totalCount} automatów
                </span>
              </div> */}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex w-100 justify-content-start align-items-center">

      {ToggleVisibility}
    </div>
  );
}
